import React from 'react'
import { Invoices } from '@layerfi/components'

export const InvoicesPage = () => {
  return <Invoices />
}
